import { selectIsInternalAdmin } from 'accessors'
import moment from 'moment'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

import Bar from '../../../components/ReusableComponents/BarChart'
import { ReactComponent as AttentionIcon } from './attention.svg'
import styles from './ReviewRow.module.scss'
import { ReactComponent as StarIcon } from './star.svg'

const ReviewRow = ({
  checkOutDate,
  subscriberCount,
  checkOutCount,
  reviewRequestCount,
  reviewReceiveCount,
  averageRating,
  receivedCommentCount
}) => {
  const isInternalAdmin = useSelector(selectIsInternalAdmin)

  return (
    <div className={styles.row}>
      <div className={styles.dateCol}>{moment(checkOutDate).format('MMM DD')}</div>
      {isInternalAdmin ? (
        <div className={styles.checkOutsCol}>
          {checkOutCount} checkouts <br /> {subscriberCount} subscribers
        </div>
      ) : (
        <div className={styles.checkOutsCol}>{checkOutCount} checkouts</div>
      )}
      <div className={styles.invitesCol}>
        <p
          className={[
            styles.progressText,
            subscriberCount ? styles.progressTextSuccess : styles.progressTextInactive
          ].join(' ')}
        >
          {subscriberCount ? (
            <>Sent {reviewRequestCount} invites</>
          ) : (
            <>Sending {reviewRequestCount} invites</>
          )}
        </p>
        <Bar percent={(subscriberCount / subscriberCount) * 100} color="#0D80FF" />
      </div>
      <div className={styles.avgCol}>
        <p>
          Avg.{' '}
          <span className={styles.avgNumber}>
            {averageRating.toFixed(1)} <StarIcon />
          </span>
        </p>
        {receivedCommentCount > 0 && (
          <p className={styles.attentionLine}>
            <AttentionIcon /> Needs attention
          </p>
        )}
      </div>
      <div className={styles.ctaCol}>
        {reviewReceiveCount ? (
          <Link to={`/reviews/${moment(checkOutDate).format('YYYY-MM-DD')}`}>
            <button className={styles.cta}>
              {reviewReceiveCount} {reviewReceiveCount > 1 ? 'reviews' : 'review'}
            </button>
          </Link>
        ) : (
          <button className={styles.inactiveCta} disabled>
            No reviews
          </button>
        )}
      </div>
    </div>
  )
}

export default ReviewRow
